var React = require('react');

function CheckmarkCirc (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15ZM10.1707 4.6683L10.7561 4L12 5.26781L11.4146 5.93612L6.69512 11.312L6.09146 12L5.46951 11.3317L3.60366 9.33661L3 8.68796L4.21646 7.38084L4.82012 8.02948L6.05488 9.35627L10.1707 4.6683Z","fill":"currentColor"}));
}

CheckmarkCirc.defaultProps = {"aria-hidden":"true","width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = CheckmarkCirc;

CheckmarkCirc.default = CheckmarkCirc;
